import { render } from "./TransporterDetail.vue?vue&type=template&id=d545483a"
import script from "./TransporterDetail.vue?vue&type=script&lang=js"
export * from "./TransporterDetail.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__